import { routerGetCall } from '../../axios';

const getPolicyExternalLinks = (state, params) => {
    const url = `/accounts/policies/${params?.policyId}/external-links`;
    return routerGetCall(state, url, {});
};
export default { getPolicyExternalLinks };
